/* eslint-disable no-undef */
import { isNullOrWhitespace } from "@common/Common";
import $ from 'jquery';
import JSZip from "jszip";

(window as any).JSZip = JSZip;
export class KendoGrid
{
    ElementId: string = null;
    private DataSource: kendo.data.DataSource;

    private Fields: KendoGridField[] = [];

    private OnColumnShowHandler: (e: any) => void;
    private OnColumnMenuInitHandler: (e: any) => void;
    private OnGridChangeHandler: (e: any) => void;
    private ProgressBarFields: string[] = [];
    private CumulativeFields: string[] = [];
    private ProgressBarColor: (e: any) => string;
    private ProgressMaxValue: (field: string) => number;

    constructor(idField: string, fields: KendoGridField[], changeHandler: (e: any) => void)
    {
        this.CleanUI();

        this.Fields = fields;
        this.ProgressBarFields = fields.filter(f => f.IsBarDefault).map(f => f.FieldId);

        const fieldsObj: any = {};

        fields.forEach(field =>
        {
            fieldsObj[field.FieldId] = { type: field.Type };
        });

        this.DataSource = new kendo.data.DataSource(
        {
            data: [],
            schema:
            {
                model:
                {
                    id: idField,
                    fields: fieldsObj
                }
            },
            change: changeHandler
        });
    }

    Get(): kendo.ui.Grid
    {
        return $(`#${this.ElementId}`).data("kendoGrid");
    }

    private CleanUI()
    {
        const grid = this.Get();

        if (grid)
        {
            grid.destroy();
        }

        const gridElement = $(`#${this.ElementId}`);

        if (gridElement)
        {
            gridElement.parent().empty();
        }
    }

    GetOptions(): KendoGridOptions
    {
        const grid = this.Get();

        if (grid)
        {
            const options = grid.getOptions();
            return KendoGridOptions.Create(options);
        }

        return null;
    }

    GetJsonSettings(): string
    {
        const grid = this.Get();
        const ds = grid.dataSource;

        const saveableOptions = new SaveableOptions();
        saveableOptions.Columns = grid.getOptions().columns.filter(c => c.command == null || !c.selectable);
        saveableOptions.GroupingOptions = (ds.group() == null || ds.group().length === 0) ? null : { field: ds.group()[0].field, dir: ds.group()[0].dir };
        saveableOptions.SortingOptions = (ds.sort() == null || ds.sort().length === 0) ? null : { field: ds.sort()[0].field, dir: ds.sort()[0].dir };
        saveableOptions.ProgressBarFields = this.ProgressBarFields;
        saveableOptions.CumulativeFields = this.CumulativeFields;
        saveableOptions.Filters = ds.filter();
        return JSON.stringify(saveableOptions);         
    }

    static GetSavedColumns(jsonOptions: string): kendo.ui.GridColumn[] | null
    {       
        if (isNullOrWhitespace(jsonOptions))
        {
            return null;
        }

        const savedOptions: SaveableOptions = JSON.parse(jsonOptions);

        if (savedOptions.Columns)
        {
            return savedOptions.Columns as kendo.ui.GridColumn[];
        }
        else
        {
            return null;
        }
    }

    LoadSettings(jsonOptions: string)
    {
        if (!isNullOrWhitespace(jsonOptions))
        {
            const savedOptions: SaveableOptions = JSON.parse(jsonOptions);

            if (savedOptions)
            {
                if (savedOptions.GroupingOptions)
                {
                    this.Group(savedOptions.GroupingOptions.field, savedOptions.GroupingOptions.dir);
                }

                if (savedOptions.SortingOptions)
                {
                    this.Sort(savedOptions.SortingOptions.field, savedOptions.SortingOptions.dir);
                }

                if (savedOptions.ProgressBarFields)
                {
                    this.ProgressBarFields = savedOptions.ProgressBarFields;
                }

                if (savedOptions.CumulativeFields)
                {
                    this.CumulativeFields = savedOptions.CumulativeFields;
                }

                if (savedOptions.Filters)
                {
                    this.DataSource.filter(savedOptions.Filters);
                }
            }
        }
    }

    Sort(field: string, dir: string)
    {
        this.DataSource.sort({ field: field, dir: dir });
    }

    Group(field: string, dir: string)
    {
        this.DataSource.group({ field: field, dir: dir });
    }

    ClearFilters(): void
    {
        this.DataSource.filter({});
    }

    //ShowColumnsEditor()
    //{
    //    const columns = this.GetOptions().GetColumns()
    //        .filter(c => c.command == null)
    //        .filter(c => c.hidden !== true)
    //        .map(c => new KendoGridColumn(c.field, c.title));

    //    const fields = this.GetFields();
    //    const columnEditor = new KendoGridColumnsEditor(fields, columns, (ids) => { this.SetColumns(ids); });
    //    columnEditor.RenderDialog();
    //}

    SetColumns(fieldsIds: string[])
    {
        const fieldsSet = new Set(fieldsIds);

        const fields = this.GetFields();

        const ds = this.DataSource;
        const groupingFieldId: string = (ds.group() == null || ds.group().length === 0) ? null : ds.group()[0].field;

        const options = this.GetOptions();

        let columns = options.GetColumns().filter(c => c.hidden !== true);

        columns = columns.filter((c) =>
        {
            if (!fieldsSet.has(c.field))
            {
                if (c.field === groupingFieldId)
                {
                    c.hidden = true; // Hide grouping column
                    return true; // Keep this column
                }
                //else if (c.title === "Actions")
                //{
                //    return true; // Keep action columns as is
                //}
                else if (c.selectable === true)
                {
                    return true; // Keep selectable columns as is
                }
                else if (c.command == null)
                {
                    return false; // Remove columns without a command
                }
            }
            return true; // Keep all other columns
        });


        const addedFieldsIds = fieldsIds.filter(a => !columns.some(b => b.field === a));
        const addedFields = fields.filter(a => addedFieldsIds.includes(a.FieldId));

        const addedCols = KendoGridOptions.BuildColumns(addedFields);
        addedCols.forEach(c => { c.hidden = false; c.width = 90 });
        addedCols.forEach(c => c.filterable = { multi: true, search: true });
        columns.push(...addedCols);

        // Ensure "Actions" column is the last column
        //const actionsColumnIndex = columns.findIndex(c => c.title === "Actions");
        //if (actionsColumnIndex > -1)
        //{
        //    const actionsColumn = columns.splice(actionsColumnIndex, 1)[0]; // Remove it
        //    columns.push(actionsColumn); // Append it to the end
        //}

        options.SetColumns(columns);
        this.SetOptions(options);

        this.RenderProgressBars();
    }


    GetData()
    {
        return this.DataSource.data().map(a => a);
    }

    GetDataItem(itemId: any)
    {
        return this.DataSource.get(itemId);
    }

    removeDataItem(itemId: any)
    {
        const grid = this.Get();

        const dataSource = grid.dataSource;

        // Find the item by ID in the data source
        const item = dataSource.get(itemId);

        if (item)
        {
            // Remove the item from the data source
            dataSource.remove(item);

            // Refresh the grid to reflect the changes
            grid.refresh();
        } else
        {
            console.warn(`Item with ID ${itemId} not found in the grid.`);
        }
    }

    replaceRow(newItemData: any, key: string)
    {
        // Extract the item ID using the provided key
        const itemId = newItemData[key];

        if (!itemId)
        {
            console.warn(`The new item data must contain a '${key}' property.`);
            return;
        }

        const grid = this.Get();

        const dataSource = grid.dataSource;

        // Remove the existing item
        const existingItem = dataSource.get(itemId);
        if (existingItem)
        {
            dataSource.remove(existingItem);
        }

        // Add the new item
        dataSource.add(newItemData);

        // Refresh the grid
        grid.refresh();
    }


    AddField(field: KendoGridField)
    {
        this.Fields.push(field);
        this.DataSource.options.schema.model.fields[field.FieldId] = { type: field.Type };
    }

    GetFields(): KendoGridField[]
    {
        return this.Fields;
    }

    GetShownFieldsIds(): string[]
    {
        const options = this.GetOptions();
        return options.GetColumns().filter(c => c.hidden !== true).map(a => a.field);
    }


    SetData(data: any[])
    {
        this.DataSource.data(data);
    }

    IsProgressBarField(field: string): boolean
    {
        return this.ProgressBarFields.includes(field);
    }

    IsCumulativeField(field: string): boolean
    {
        return this.CumulativeFields.includes(field);
    }

    SetProgressBarColor(getColor: (e: any) => string)
    {
        this.ProgressBarColor = getColor;
    }

    SetProgressBarMaxValue(getMaxValue: (field: string) => number)
    {
        this.ProgressMaxValue = getMaxValue;
    }

    ToggleProgressBar(fieldName: string)
    {
        if (this.ProgressBarFields.some(f => f === fieldName))
        {
            this.DestroyProgressBar(fieldName);            
        }
        else
        {
            this.RenderProgressBar(fieldName);
        }
    }

    ToggleCumulative(fieldName: string)
    {
        if (this.CumulativeFields.some(f => f === fieldName))
        {
            this.DestroyCumulativeColumn(fieldName);
        }
        else
        {
            this.RenderCumulativeColumn(fieldName);
        }
    }



    SetOptions(options: KendoGridOptions)
    {
        const grid = this.Get();

        if (grid)
        {
            const op = options.Get();

            //required bc getOptions lose handlers
            op.columnMenuInit = this.OnColumnMenuInitHandler;
            op.change = this.OnGridChangeHandler;
            //

            grid.setOptions(op);            
            this.DataSource = grid.dataSource;
            //grid.setDataSource(this.DataSource); // overwrite this.ds or
            //console.log(`Obj is: ${Object.is(grid.dataSource, this.DataSource)}`);
        }
    }

    SetOnColumnShow(handler: (e: any) => void)
    {
        this.OnColumnShowHandler = handler;
    }


    Export()
    {
        const grid = this.Get();

        if (grid)
        {
            grid.saveAsExcel();
        }        
    }

    //Render(options: KendoGridOptions)
    //{
    //    const kOptions = options.Get();
    //    this.OnGridChangeHandler = kOptions.change;
    //    this.OnColumnMenuInitHandler = kOptions.columnMenuInit;
    //    kOptions.dataSource = this.DataSource;

    //    $(`#${this.ElementId}`).kendoGrid(kOptions);

    //    this.RenderProgressBars();
    //    this.RenderCumulativeColumns();
    //}

    Render1(elementId: string, options: KendoGridOptions)
    {
        this.ElementId = elementId;

        const kOptions = options.Get();
        this.OnGridChangeHandler = kOptions.change;
        this.OnColumnMenuInitHandler = kOptions.columnMenuInit;
        kOptions.dataSource = this.DataSource;

        $(`#${this.ElementId}`).kendoGrid(kOptions);

        this.RenderProgressBars();
        this.RenderCumulativeColumns();
    }

    RenderProgressBar(fieldName: string)
    {
        const grid = this.Get();

        if (grid)
        {
            const options = this.GetOptions();
            const columns = options.GetColumns();
            const column = columns.find(c => c.field === fieldName);

            if (column)
            {
                //e = dataItem
                column.template = (e: any): string =>
                {
                    const maxValue = this.ProgressMaxValue(fieldName);
                    const bgColorCss = this.ProgressBarColor(e);
                    const value: number = e[fieldName];
                    const progress = (value != null && maxValue != null && maxValue > 0) ? 100 * value / maxValue : 0;

                    let valueStr = "";

                    if (value != null)
                    {
                        const colFormat = column.format ?? "{0:###,###,###,###.###############}";
                        valueStr = kendo.format(colFormat, value);
                    }

                    const textColorCss = progress < 10 ? 'text-dark' : '';

                    const template = `<div class="progress" style="height: 26px;" title="${valueStr}"><div class="progress-bar ${bgColorCss} ${textColorCss}" role="progressbar" style="width: ${progress}%;">${valueStr}</div></div>`;
                    return template;
                };

                if (!this.ProgressBarFields.some(f => f === fieldName))
                {
                    this.ProgressBarFields.push(fieldName);
                }

                this.SetOptions(options);
            }
        }
    }

    DestroyProgressBar(fieldName: string)
    {
        const grid = this.Get();

        if (grid)
        {
            const options = this.GetOptions();
            const columns = options.GetColumns();
            const column = columns.find(c => c.field === fieldName);

            if (column)
            {
                column.template = null;
                this.ProgressBarFields.remove(fieldName);
                this.SetOptions(options);
            }
        }
    }

    RenderProgressBars()
    {
        this.ProgressBarFields.forEach(f =>
        {
            this.RenderProgressBar(f);
        });
    }



    Refresh()
    {
        const grid = this.Get();
        grid.refresh();
    }


    RenderCumulativeColumn(fieldName: string)
    {
        const grid = this.Get();

        if (grid)
        {
            const options = this.GetOptions();
            const columns = options.GetColumns();
            const column = columns.find(c => c.field === fieldName);

            if (column)
            {
                column.template = (e: kendo.data.Model): string =>
                {
                    const view = this.DataSource.view();

                    const index = view.indexOf(e);

                    const sum = view.slice(0, index + 1)
                        .map(a => a[fieldName])
                        .reduce((sum, current) => sum + current, 0);

                    const colFormat = column.format ?? "{0:###,###,###,###.###############}";
                    const valueStr = kendo.format(colFormat, sum);
                    return `<strong>${valueStr}</strong>`;
                };

                if (!this.CumulativeFields.some(f => f === fieldName))
                {
                    this.CumulativeFields.push(fieldName);
                }

                this.SetOptions(options);
            } 
        }
    }

    DestroyCumulativeColumn(fieldName: string)
    {
        const grid = this.Get();

        if (grid)
        {
            const options = this.GetOptions();
            const columns = options.GetColumns();
            const column = columns.find(c => c.field === fieldName);

            if (column)
            {
                column.template = null;
                this.CumulativeFields.remove(fieldName);
                this.SetOptions(options);
            }
        }        
    }

    RenderCumulativeColumns()
    {
        this.CumulativeFields.forEach(f =>
        {
            this.RenderCumulativeColumn(f);
        });
    }


    SetColumnFormat(fieldName: string, format: string)
    {
        const options = this.GetOptions();
        const columns = options.GetColumns();
        const column = columns.find(c => c.field === fieldName);

        if (column)
        {
            column.format = format;
            this.SetOptions(options);

            if (this.IsProgressBarField(fieldName))
            {
                this.RenderProgressBar(fieldName);
            }

            if (this.IsCumulativeField(fieldName))
            {
                this.RenderCumulativeColumn(fieldName);
            }
        }
    }

    SetCustomColumnMenu(gridOptions: KendoGridOptions)
    {
        const onColumnMenuInit = (e: any) =>
        {
            $(".k-sort-asc").hide();
            $(".k-sort-desc").hide();
            $(".k-columns-item").hide();

            const fieldId: string = e.field;
            const field = this.GetFields().find(f => f.FieldId === fieldId);

            if (field && field.Type === "number")
            {
                const menu: kendo.ui.Menu = e.container.find(".k-menu").data("kendoMenu");

                menu.append({ text: "Bar on/off" });
                menu.append({ text: "Cumulative on/off" });
                menu.append({
                    text: "Decimals",
                    items: [{ text: "None" }, { text: "1" }, { text: "2" }, { text: "3" }, { text: "4" }, { text: "5" }]
                });

                menu.bind("select", (e: any) =>
                {
                    if ($(e.item).text() === "Bar on/off")
                    {
                        this.ToggleProgressBar(fieldId);
                    }
                    else if ($(e.item).text() === "Cumulative on/off")
                    {
                        this.ToggleCumulative(fieldId);
                    }
                    else if ($(e.item).text() === "None")
                    {
                        this.SetColumnFormat(fieldId, "{0:n0}");
                    }
                    else if ($(e.item).text() === "1")
                    {
                        this.SetColumnFormat(fieldId, "{0:n1}");
                    }
                    else if ($(e.item).text() === "2")
                    {
                        this.SetColumnFormat(fieldId, "{0:n2}");
                    }
                    else if ($(e.item).text() === "3")
                    {
                        this.SetColumnFormat(fieldId, "{0:n3}");
                    }
                    else if ($(e.item).text() === "4")
                    {
                        this.SetColumnFormat(fieldId, "{0:n4}");
                    }
                    else if ($(e.item).text() === "5")
                    {
                        this.SetColumnFormat(fieldId, "{0:n5}");
                    }
                });
            }
        };

        gridOptions.SetOnColumnMenuInit(onColumnMenuInit);
    }
}

export class KendoGridOptions
{
    Options: kendo.ui.GridOptions;

    private constructor(options: kendo.ui.GridOptions)
    {
        this.Options = options;
    }

    static Create(gridOptions: kendo.ui.GridOptions): KendoGridOptions
    {
        const options = new KendoGridOptions(gridOptions);
        return options;
    }

    static CreateDefault(): KendoGridOptions
    {
        const options = new KendoGridOptions({
            columns: [],
            scrollable: true,
            reorderable: true,
            resizable: true,
            columnMenu: true,
            groupable: true,
            filterable: true,
            sortable: { allowUnsort: false },
            excel: { fileName: "grid.xlsx", filterable: true },
        });

        return options;
    }


    static BuildColumns(fields: KendoGridField[]): kendo.ui.GridColumn[]
    {
        const columns: kendo.ui.GridColumn[] = [];

        fields.filter(f => f.HasColumn === true).forEach(f =>
        {
            columns.push({ field: f.FieldId, title: f.ColumnTitle, format: f.Format, hidden: f.ColumnHidden, template: f.Template ?? null });
        });

        return columns;
    }

    Get(): kendo.ui.GridOptions
    {
        return this.Options;
    }

    SetColumns(columns: kendo.ui.GridColumn[])
    {        
        this.Options.columns = columns;
    }

    GetColumns(): kendo.ui.GridColumn[]
    {
        return this.Options.columns;
    }


    SetHeight(height: number)
    {
        this.Options.height = height;
    }

    SetGroupable(groupable: boolean)
    {
        this.Options.groupable = groupable;
    }

    SetSelectable(enable: boolean)
    {
        if (enable)
        {
            this.Options.selectable = "multiple, row";
        }
    }

    SetOnGridChange(handler: (e: any) => void)
    {
        this.Options.change = handler;
    }

    SetOnColumnMenuInit(handler: (e: any) => void)
    {
        this.Options.columnMenuInit = handler;
    }

}

export class KendoGridField
{
    FieldId: string;
    Type: string;
    HasColumn: boolean; 
    ColumnTitle: string;
    ColumnHidden?: boolean = false;
    Format?: string;
    Section?: string;
    Template?: string;
    IsBarDefault: boolean = false;

    constructor(fieldId: string, type: string, hasColumn: boolean, columnTitle: string, format?: string, section?: string, template?: string)
    {
        this.FieldId = fieldId;
        this.Type = type;
        this.HasColumn = hasColumn;
        this.ColumnTitle = columnTitle;
        this.Format = format;
        this.Section = section;
        this.Template = template;
    }
}

export type KendoFieldValue = string | number | Date | boolean;

export interface KendoGridRow
{
    [key: string]: KendoFieldValue;
}

export class KendoGridColumn
{
    field?: string;
    title: string;
    format?: string;
    hidden?: boolean;
    width?: string;
    template?: any;
    command?: any;
    headerAttributes?: any;
    filterable?: any;
    constructor(fieldId: string, title: string)
    {
        this.field = fieldId;
        this.title = title;
    }
}



class SaveableOptions
{
    Columns: any[];
    GroupingOptions: { field: string, dir: string };
    SortingOptions: { field: string, dir: string };
    ProgressBarFields: string[];
    CumulativeFields: string[];
    Filters: kendo.data.DataSourceFilters;
}
